import { combineReducers } from 'redux-immutable';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import Immutable from 'immutable';
import { authReducer } from '../../util/auth';
import { intlReducer } from '../../util/intl';
import uiReducer from './uiReducer';
import deviceReducer from './deviceReducer';
import userReducer from './userReducer';
import accountReducer from './accountReducer';

/* istanbul ignore next */
const enhancer = process.env.NODE_ENV === 'development'
  ? compose(
    // Middleware you want to use in development:
    applyMiddleware(thunk, promiseMiddleware()),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  )
  : compose(applyMiddleware(thunk, promiseMiddleware()));

export const rootReducer = combineReducers({
  auth: authReducer,
  intl: intlReducer,
  ui: uiReducer,
  device: deviceReducer,
  user: userReducer,
  account: accountReducer,
});

export const store = createStore(rootReducer, Immutable.fromJS({}), enhancer);

export default rootReducer;
